<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="$_cancle"
    lock-scroll
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="greater"
    class="modal-button-manager"
  >
    <div class="content">
      <div class="content-header">
         <!-- 面包屑 -->
        <div class="breadcrumb">
          <template v-for="(item, index) in paths">
            <span
             :key="item.code"
              v-if="index !== paths.length - 1"
            >
              <a
                href="javascript:void(0);"
                @click="$_pathTo(index, item)"
              >{{item.name}}</a>
              <span class="split">/</span>
            </span>
            
            <span v-else :key="index" class="active">{{item.name}}</span>
          </template>
        </div>
        <el-button @click="$_modify(-1)" class="btn__add">新增按钮</el-button>
      </div>
      <div class="table-box">
        <el-table
          v-loading="isLoading"
          ref="tableList"
          :data="dataList"
          height="450"
          stripe
          tooltip-effect="dark"
        >
          <el-table-column label="操作" width="308" :resizable="false">
            <template slot-scope="scope">
              <el-button class="edit__btn" @click="$_modify(scope.row)">编辑</el-button>
              <el-button class="delete__btn" @click="$_updateStatus(scope.row, 3)">删除</el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-for="column in columns"
            :key="column.key"
            :prop="column.key"
            :label="column.label"
            :width="column.width"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <div class="pagination__wrapper">
          <cd-pagination
            ref="pager"
            :total="pagination.total"
            :currPage="pagination.pageNow"
            :pageSize="pagination.pageSize"
            @changepage="$_changeCurrent"
            @changesize="$_changeSize"
            :explainShow="true"
            @refresh="$_getDataList"
          ></cd-pagination>
        </div>
      </div>
    </div>
    <!-- S 新增/编辑按钮 弹窗 -->
    <modify-button
      v-if="modal.show && modal.template==='modify-button'"
      :title="modal.title"
      :formType="modal.type"
      :menuItem="menuItem"
      :buttonObj="modal.data"
      @callback="$_callbackModify"
      @close="$_close"
    ></modify-button>
    <!-- E 新增/编辑按钮 弹窗 -->
  </el-dialog>
</template>

<script>
import ModifyButton from "./modal-modify-button";
export default {
  name: "button-manager",
  props: ["title", "paths", "menuItem"],
  data() {
    const columns = [
      { key: "code", label: "按钮编码", width: 200 },
      { key: "name", label: "按钮名称", width: 200 },
      { key: "statusStr", label: "是否显示" }
    ];
    return {
      visible: false,
      isLoading: false,
      columns,
      dataList: [],
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        template: "",
        title: "",
        type: "",
        data: ""
      }
    };
  },
  methods: {
    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
    // 获取按钮列表
    $_getDataList() {
      this.isLoading = true;
      let functionId = this.menuItem.fid;
      let { pageNow, pageSize } = this.pagination;
      this.$service
        .post("getButtonList", {
          functionId,
          pageNow,
          pageSize
        })
        .then(result => {
          this.isLoading = false;
          if (result.$.checkResult(result, true)) {
            this.pagination.pages = result.data.pages;
            this.pagination.total = result.data.total;
            this.dataList = result.data.rows.map(item => {
              let statusStr = item.status === 1 ? "显示" : "不显示";
              return {
                statusStr,
                ...item
              };
            });
          }
        });
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getDataList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getDataList();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    $_callbackModify() {
      this.$_getDataList();
      this.$_close();
    },
    // 新增/编辑 按钮
    $_modify(row) {
      this.modal.template = "modify-button";
      if (row === -1) {
        this.modal.type = "add";
        this.modal.title = "新增按钮";
      } else {
        this.modal.type = "edit";
        this.modal.title = "编辑按钮";
        this.modal.data = { ...row };
      }
      this.modal.show = true;
    },
    // 修改状态 1: 显示 2: 不显示 3: 删除
    $_updateStatus(row, status) {
      let content = "";
      if (status === 3) {
        content = `<p>是否删除当前选项？</p><p class="error-text">*删除按钮会影响角色操作权限,请谨慎操作！</p>`;
      }
      let _this = this;
      $MessageBox.confirm({
        content,
        onOk() {
          _this.isLoading = true;
          _this.$service
            .post("updateButtonStatus", {
              bid: row.bid,
              status: 3
            })
            .then(result => {
              _this.isLoading = false;
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    _this.$_getDataList();
                  }
                });
              }
            });
        }
      });
    },
    // 顶部导航
    $_pathTo(index, menu) {
      this.$emit("path-to", index, menu);
      this.$_cancle();
    }
  },
  components: {
    ModifyButton
  },
  mounted() {
    this.visible = true;
    this.$nextTick(() => {
      this.$_getDataList();
    });
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 20px;
  &-header {
    overflow: hidden;
  }
}
.breadcrumb {
  padding: 0 0 10px;
}
.btn__add {
  display: block;
  margin-bottom: 14px;
}
.table-box {
  height: 496px;
  border: 1px solid #eee;
}
.modal-button-manager {
  /deep/ .el-dialog {
    .el-dialog__body {
      height: 642px;
    }
  }
}
</style>
